$(document).ready(function ()
{
  console.log('enable_carousel::: ', enable_carousel);
  if (enable_carousel == 'true') 
  {
    $('.icon-bar_slider').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: '<button class="slick-prev custom-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
      nextArrow: '<button><svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg> </button>',
      responsive: [
        
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 467,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });    
  }

  var mySwiper = new Swiper ('.collection_slider', {
    autoplay: {
      delay:0,
      disableOnInteraction: false
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    loop: true,
    infinite: true,
    speed: 5000,

    // If we need pagination
    // pagination: '.swiper-pagination',
    
    // // Navigation arrows
    // nextButton: '.swiper-button-next',
    // prevButton: '.swiper-button-prev',
  });

});